<template>
  <el-form
    ref="ruleForm"
    :model="inspect"
    :rules="rules"
    label-position="top">
    <el-row :gutter="20">
      <!-- <el-col :span="8">
        <el-form-item label="检测报告名称:"
          prop="inspectReportName">
          <el-input v-model="inspect.inspectReportName"></el-input>
        </el-form-item>
      </el-col> -->
      <el-col :span="8">
        <el-form-item
          label="检测编号:"
          prop="certNumber">
          <span v-if="isDetail">{{ inspect.certNumber }}</span>
          <el-input
            v-else
            v-model="inspect.certNumber"></el-input>
        </el-form-item>
      </el-col>
      <!-- <el-col :span="8">
        <el-form-item label="贸易类型:">
          {{inspect.tradeType | tradeType()}}
        </el-form-item>
      </el-col> -->
      <!-- <el-col :span="8">
        <el-form-item
          label="管理/服务机构:"
          prop="regulatorId">
          <vendor-regulator-select
            v-model="inspect.regulatorId"
            :status="isDetail ? 'detail': 'select'"
            :callback="callback"
            :option="{vendorId: inspect.vendorId, tradeType: inspect.tradeType}" />
        </el-form-item>
      </el-col> -->
      <el-col :span="8">
        <el-form-item
          label="检测人员:"
          prop="inspector">
          <span v-if="isDetail">{{ inspect.inspector }}</span>
          <el-input
            v-else
            v-model="inspect.inspector"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="检测时间:"
          prop="inspectionTime">
          <span v-if="isDetail">{{ inspect.inspectionTime | dateformat('YYYY-MM-DD') }}</span>
          <el-date-picker
            v-else
            v-model="inspect.inspectionTime"
            style="width: 100%"
            type="date"
            placeholder="选择检测时间">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="检测地址:"
          prop="inspectionAddress">
          <span v-if="isDetail">{{ inspect.inspectionAddress }}</span>
          <el-input
            v-else
            v-model="inspect.inspectionAddress"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item
          label="检测报告:"
          prop="certFile">
          <custom-upload-file
            v-model="inspect.certFile"
            :limit="50"
            :status="isDetail ? 'detail' : 'edit'"
            accept="image/*,.pdf" />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import CustomUploadFile from '@/components/public/custom-upload-file.vue'
// import VendorRegulatorSelect from './vendor-regulator-select.vue'
import clonedeep from 'lodash.clonedeep'
export default {
  name: 'InspectHomeForm',
  components: { CustomUploadFile },
  props: {
    cb: {
      type: Function
    },
    isDetail: {
      type: Boolean,
      default: false
    },
    value: {
      required: true
    }
  },
  data() {
    return {
      rules: {
        // inspectReportName: [
        //   { required: true, message: '请输入检测报告名称', trigger: 'blur' },
        //   { max: 30, message: '长度最多 30 个字符', trigger: 'blur' }
        // ],
        certNumber: [
          { required: true, message: '请输入检测编号', trigger: 'blur' }
        ],
        certFile: [
          { type: 'array', required: true, message: '请上传检测报告', trigger: 'change' }
        ],
        regulatorId: [
          { required: true, message: '请选择管理/服务机构', trigger: 'blur' }
        ],
        inspector: [
          { required: true, message: '请输入检测人员', trigger: 'blur' }
        ],
        inspectionTime: [
          { required: true, message: '请选择检测时间', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    inspect: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    callback(v) {
      this.cb && this.cb(v)
    },
    submit(cb) {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const inspect = clonedeep(this.inspect)
          inspect.certFile = inspect.certFile.map(item => item.url).join(',')
          inspect.inspectionTime = inspect.inspectionTime ? +inspect.inspectionTime : inspect.inspectionTime
          cb && cb(inspect)
        }
      })
    }
  }
}
</script>
